module.exports = __webpack_public_path__ + "static/media/tk.466dce74.jpeg";